export const DIDIMO_GENERATING_UPDATE_TIME = 1000 * 10; // 10 seconds
export const DIDIMO_DOWNLOAD_UPDATE_TIME = 1000 * 5; // 5 seconds

// Hierarchical-settings scopes gating portal features. Owned and registered by
// api-accounts (Core/Configuration/PortalFeatures.cs) — keep the strings in sync.
export const FEATURE_DIDIMO_GENERATION =
  'feature.customerportal.didimo-generation';
